import SectionFields from "@/pages/admin/SectionFields";
import ImageUploader from "@/pages/admin/ImageUploader";
import { SECTION_SCHEMA } from "@/pages/admin/schema";
import { Plus, Trash2, ChevronLeft, ChevronRight } from "lucide-react";

function ImageListField({ label, value, onChange }) {
  const arr = Array.isArray(value) ? value : [];
  const setArr = (a) => onChange(a);
  const move = (from, to) => {
    if (to < 0 || to >= arr.length) return;
    const a = arr.slice();
    const [it] = a.splice(from, 1);
    a.splice(to, 0, it);
    setArr(a);
  };
  return (
    <div className="border border-ink/15 p-3" data-testid="about-gallery-list">
      <div className="flex items-center justify-between mb-3">
        <span className="eyebrow text-ink/60">{label} · {arr.length}</span>
        <button
          type="button"
          onClick={() => setArr([...arr, ""])}
          data-testid="about-gallery-add"
          className="eyebrow inline-flex items-center gap-1 border border-ink px-2 py-1 hover:bg-ink hover:text-paper transition-colors"
        >
          <Plus size={12} /> Adaugă foto
        </button>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        {arr.map((img, i) => (
          <div key={i} className="border border-ink/10 bg-ink/[0.02] p-2">
            <div className="flex items-center justify-between mb-1.5">
              <span className="eyebrow text-ink/40">#{i + 1}</span>
              <div className="flex gap-1">
                <button type="button" onClick={() => move(i, i - 1)} className="p-1 hover:bg-ink/10" title="Stânga"><ChevronLeft size={13} /></button>
                <button type="button" onClick={() => move(i, i + 1)} className="p-1 hover:bg-ink/10" title="Dreapta"><ChevronRight size={13} /></button>
                <button type="button" onClick={() => setArr(arr.filter((_, j) => j !== i))} data-testid={`about-gallery-del-${i}`} className="p-1 text-red-700 hover:bg-red-700/10" title="Șterge"><Trash2 size={13} /></button>
              </div>
            </div>
            <ImageUploader value={img} onChange={(v) => setArr(arr.map((x, j) => (j === i ? v : x)))} testid={`about-gallery-uploader-${i}`} />
          </div>
        ))}
        {arr.length === 0 && <div className="eyebrow text-ink/30 py-2">Nicio fotografie. Apasă „Adaugă foto".</div>}
      </div>
    </div>
  );
}

export default function PageEditor({ draft, setDraft, lang, setLang, sectionKey, title, images = [], imageLists = [] }) {
  const setContent = (obj) =>
    setDraft((d) => ({
      ...d,
      content: { ...d.content, [lang]: { ...d.content[lang], [sectionKey]: obj } },
    }));

  const setImage = (key, v) =>
    setDraft((d) => ({ ...d, images: { ...d.images, [key]: v } }));

  return (
    <div className="max-w-3xl">
      <div className="flex items-center justify-between mb-6">
        <div className="eyebrow text-ink/50">Editezi „{title}" în limba:</div>
        <div className="flex items-center gap-1 eyebrow border border-ink/25">
          <button onClick={() => setLang("ro")} data-testid={`${sectionKey}-lang-ro`} className={`px-4 py-2 ${lang === "ro" ? "bg-ink text-paper" : ""}`}>RO</button>
          <button onClick={() => setLang("en")} data-testid={`${sectionKey}-lang-en`} className={`px-4 py-2 ${lang === "en" ? "bg-ink text-paper" : ""}`}>EN</button>
        </div>
      </div>

      {images.length > 0 && (
        <div className="space-y-4 mb-8">
          <div className="eyebrow text-ink/60">Imagini</div>
          <div className="grid sm:grid-cols-2 gap-3">
            {images.map((img) => (
              <ImageUploader
                key={img.key}
                label={img.label}
                value={draft.images[img.key] || ""}
                onChange={(v) => setImage(img.key, v)}
                testid={`img-${img.key}`}
              />
            ))}
          </div>
        </div>
      )}

      {imageLists.length > 0 && (
        <div className="space-y-4 mb-8">
          {imageLists.map((il) => (
            <ImageListField
              key={il.key}
              label={il.label}
              value={draft.images[il.key]}
              onChange={(arr) => setImage(il.key, arr)}
            />
          ))}
        </div>
      )}

      <SectionFields
        fields={SECTION_SCHEMA[sectionKey]}
        value={draft.content[lang]?.[sectionKey] || {}}
        onChange={setContent}
        testidPrefix={`${sectionKey}.`}
      />
    </div>
  );
}
